import type { ContentNode, DocumentState } from '../document-types';
import type { NodeHandler, RenderContext } from './types';

export class BlockquoteHandler implements NodeHandler {
  readonly type = 'blockquote';

  render(
    _node: ContentNode | DocumentState,
    _parent: ContentNode | DocumentState | null,
    childContent: string,
    _ctx: RenderContext
  ): string {
    return (
      childContent
        .split('\n')
        .map((line) => (line ? '> ' + line : '>'))
        .join('\n') + '\n\n'
    );
  }
}
